import HeaderOne from "./HeaderOne";
import HeaderTwo from "./HeaderTwo";
import HeaderThree from "./HeaderThree";
import HeaderFour from "./HeaderFour";
import HeaderFive from "./HeaderFive";
import HeaderSix from "./HeaderSix";
import HeaderSeven from "./HeaderSeven";
import HeaderComponent from './HeaderComponent'
export default HeaderComponent
export {
  HeaderOne,
  HeaderTwo,
  HeaderThree,
  HeaderFour,
  HeaderFive,
  HeaderSix,
  HeaderSeven
}